module.exports = __webpack_public_path__ + "burj-khalifa.98c48e7ba589b8065bf9a9fbf3aff2ce.jpg";